import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const TableSelectionHeader = ({
  enableSelection,
  processedData,
  selectedRows,
  getRowKey,
  onSelectAll,
}) => {
  if (!enableSelection) return null;

  const allRowKeys = processedData.map(row => getRowKey(row));
  const allSelected = allRowKeys.length > 0 && allRowKeys.every(key => selectedRows.has(key));
  const someSelected = allRowKeys.some(key => selectedRows.has(key));
  const hasAnySelection = selectedRows.size > 0;

  return (
    <th className={`selection-header ${hasAnySelection ? 'has-selection' : ''}`} key="selection">
      <div className="selection-checkbox-container">
        <button
          className={`selection-checkbox ${allSelected ? 'selected' : ''} ${someSelected && !allSelected ? 'indeterminate' : ''}`}
          onClick={onSelectAll}
          type="button"
        >
          {allSelected && <FontAwesomeIcon icon={faCheck} />}
          {someSelected && !allSelected && <span className="indeterminate-dash">−</span>}
        </button>
      </div>
    </th>
  );
};

export const TableSelectionCell = ({
  enableSelection,
  row,
  selectedRows,
  getRowKey,
  onSelect,
}) => {
  if (!enableSelection) return null;

  const rowKey = getRowKey(row);
  const isSelected = selectedRows.has(rowKey);
  const hasAnySelection = selectedRows.size > 0;

  return (
    <td
      className={`selection-cell ${hasAnySelection ? 'has-selection' : ''}`}
      key="selection"
      onClick={(event) => onSelect(row, event)}
    >
      <div className="selection-checkbox-container">
        <button
          className={`selection-checkbox ${isSelected ? 'selected' : ''}`}
          type="button"
        >
          {isSelected && <FontAwesomeIcon icon={faCheck} />}
        </button>
      </div>
    </td>
  );
};
